import { Button, Form, message, Modal, notification } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";

import { logout } from "../../../redux/Auth/authActions";
import useWindowSize from "../../../utils/useWindowSize";
import CustomLogout from "../../../components/CustomLogout/CustomLogout";
import useSession from "../../../components/CustomLogout/useSession";
import { useEffect } from "react";

const Logout = (props) => {
  const { LogoutFlag } = props;
  const handleSessionExpired = useSession();

  const [form] = Form.useForm();
  const history = useNavigate();
  const { width } = useWindowSize();
  const mobile = width < 786;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
    form.resetFields();
  };

  useEffect(() => {
    const handleEnterKeyPress = (e) => {
      if (e.key === 'Enter') {
        form.submit();
      }
    };

    if (isModalVisible) {
      window.addEventListener('keydown', handleEnterKeyPress);
    } else {
      window.removeEventListener('keydown', handleEnterKeyPress);
    }

    return () => {
      window.removeEventListener('keydown', handleEnterKeyPress);
    };
  }, [isModalVisible, form]);

  const handleLogout = () => {
    message.destroy();
    message.loading("Loading...", 0);
    props
      .logout(props.auth?.idToken)
      .then((res) => {
        console.log(res);
        message.destroy();
        if (res && res.status === 200) {
          sessionStorage.clear();
          setIsModalVisible(false);
          history("/");
          message.success(res?.data?.success?.message);
        }
        // else {
        //   message.error(res?.data?.dto?.message);
        // }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((err) => {
        message.destroy();
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  return (
    <>
      {mobile ? (
        <>
          <p
            style={{ cursor: "pointer", color: "#00b1b1", margin: 0 }}
            onClick={() => {
              showModal();
              props.hide && props.hide();
            }}
          >
            LOGOUT
            <h4>{props.userDetail?.userName}</h4>
            <h5>{props.userDetail?.roleName}</h5>
          </p>
        </>
      ) : (
        <h6 onClick={showModal}>LOGOUT </h6>
      )}
      {LogoutFlag?.logoutFlag ? (
        <CustomLogout />
      ) : (
        <Modal
          open={isModalVisible}
          closable={false}
          className="modal-container"
          centered
          footer={null}
        >
          {" "}
          <Form
            autoComplete="off"
            name="logout"
            className="change-password"
            form={form}
            onFinish={handleLogout}
          >
            <Row>
              <Col lg={12} xs={12} md={12} sm={12}>
                <Col md={12} className="headre-login">
                  <ModalHeaderText LoginHeading="Logout" />
                </Col>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col lg={12} xs={12} md={12} sm={12}>
                <p>You will be logout of the system.</p>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col md={12} className="d-flex justify-content-end mt-4">
                <Button
                  className="mr-3"
                  htmlType="button"
                  type="default"
                  onClick={handleCancel}
                >
                  CANCEL
                </Button>
                <Button className="" htmlType="submit" type="primary">
                  CONFIRM
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (user) => dispatch(logout(user)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    LogoutFlag: state.Logout,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
